import { render, staticRenderFns } from "./SelectPreferredStore.vue?vue&type=template&id=10993ad6"
import script from "./SelectPreferredStore.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectPreferredStore.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports